import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;
const inp = { width: "100%", padding: "11px 12px", border: "1px solid #ddd", borderRadius: 10, fontSize: 15, boxSizing: "border-box", fontFamily: "inherit" };

// Public "Request a quote" form for field-service shops (handyman / landscaping / HVAC).
export default function JobRequest() {
  const { slug } = useParams();
  const [store, setStore] = useState(null);
  const [f, setF] = useState({ category: "", description: "", address: "", customer_name: "", customer_phone: "", customer_email: "", preferred: "" });
  const [err, setErr] = useState("");
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    fetch(`${API}/api/public/tenant/${slug}/job-form`).then((r) => (r.ok ? r.json() : Promise.reject())).then((d) => { setStore(d); setF((x) => ({ ...x, category: d.categories[0] || "" })); }).catch(() => setStore(false));
  }, [slug]);
  if (store === false) return <div style={{ padding: 40, fontFamily: "system-ui" }} data-testid="job-form-not-found">This business isn't accepting requests online.</div>;
  if (!store) return <div style={{ padding: 40, fontFamily: "system-ui", color: "#888" }}>Loading…</div>;
  const color = store.color;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async () => {
    setErr(""); setBusy(true);
    try {
      const r = await fetch(`${API}/api/public/tenant/${slug}/job-requests`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(f) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || "Something went wrong.");
      setDone(d);
    } catch (e) { setErr(e.message); } finally { setBusy(false); }
  };
  return (
    <div style={{ maxWidth: 620, margin: "0 auto", padding: "28px 18px", fontFamily: "system-ui,-apple-system,sans-serif", color: "#111" }} data-testid="job-request-page">
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 6 }}>
        {store.logo && <img src={store.logo} alt="" width="40" height="40" style={{ borderRadius: 10, objectFit: "cover" }} />}
        <h1 style={{ fontSize: 24, margin: 0 }} data-testid="job-store-name">{store.name}</h1>
      </div>
      {done ? (
        <div style={{ textAlign: "center", padding: "30px 0" }} data-testid="job-request-done">
          <h2>Request sent!</h2>
          <p style={{ color: "#555" }}>We'll review it and send your quote. Reference <strong data-testid="job-ref">{done.ref}</strong>.</p>
          <a href={done.status_url} style={{ color }} data-testid="job-status-link">Track your request</a>
        </div>
      ) : (
        <>
          <p style={{ color: "#555", marginTop: 0 }}>{store.intro || "Tell us about the job and we'll send you a quote."}</p>
          <div style={{ display: "grid", gap: 12, marginTop: 16 }}>
            <label style={{ fontSize: 14, fontWeight: 600 }}>What do you need?
              <select style={{ ...inp, marginTop: 6 }} value={f.category} onChange={set("category")} data-testid="job-category">{store.categories.map((c) => <option key={c}>{c}</option>)}</select></label>
            <label style={{ fontSize: 14, fontWeight: 600 }}>Describe the job
              <textarea style={{ ...inp, marginTop: 6, minHeight: 110 }} value={f.description} onChange={set("description")} placeholder="What's going on, size of the area, anything we should know…" data-testid="job-description" /></label>
            <label style={{ fontSize: 14, fontWeight: 600 }}>Service address
              <input style={{ ...inp, marginTop: 6 }} value={f.address} onChange={set("address")} data-testid="job-address" /></label>
            <label style={{ fontSize: 14, fontWeight: 600 }}>When works best? <span style={{ fontWeight: 400, color: "#888" }}>(optional)</span>
              <input style={{ ...inp, marginTop: 6 }} value={f.preferred} onChange={set("preferred")} placeholder="e.g. weekday mornings, after the 15th" data-testid="job-preferred" /></label>
            <input style={inp} placeholder="Your name" value={f.customer_name} onChange={set("customer_name")} data-testid="job-name" />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              <input style={inp} placeholder="Phone" value={f.customer_phone} onChange={set("customer_phone")} data-testid="job-phone" />
              <input style={inp} placeholder="Email" value={f.customer_email} onChange={set("customer_email")} data-testid="job-email" />
            </div>
            {err && <div style={{ color: "#b00", fontSize: 14 }} data-testid="job-error">{err}</div>}
            <button onClick={submit} disabled={busy} style={{ background: color, color: "#fff", border: 0, borderRadius: 999, padding: "13px 22px", fontSize: 16, fontWeight: 600, cursor: "pointer" }} data-testid="job-submit">{busy ? "Sending…" : "Request a quote"}</button>
          </div>
        </>
      )}
      <div style={{ marginTop: 40, color: "#767676", fontSize: 12, textAlign: "center" }}>Powered by MorrCart</div>
    </div>
  );
}
